import Footer from "./app/Layout/views/Footer";
import AppRoutes from "./Routes";
import "./app.css";
import ThemeProvider from "./app/theme";

function App(props) {
  return (
    <div>
      <ThemeProvider>
        <AppRoutes />
        <Footer />
      </ThemeProvider>
    </div>
  );
}

export default App;
